jQuery(document).ready(function () {
    if (jQuery('.big_slide').length && jQuery('.min_slide_root').length) {
        initializeSliders();
    }
});

function initializeSliders() {
    jQuery('.big_slide').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        draggable: false,
        touchMove: false,
        swipeToSlide: false,
      infinite: true,
        focusOnSelect: false,
        fade: false,
        autoplay: false,
        autoplaySpeed: 8000,
        asNavFor: '.min_slide_root'
    });
    jQuery('.min_slide_root').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        asNavFor: '.big_slide',
        infinite: true,
        draggable: false,
        swipeToSlide: false,
        autoplay: false,
        
        autoplaySpeed: 8000,
        touchMove: false,
        dots: false,
        arrows: true,
        focusOnSelect: false,
        responsive: [
            {
                breakpoint: 1281,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 835,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 481,
                settings: {
                    dots: false,
                    arrows: true,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 415,
                settings: {
                    dots: false,
                    arrows: true,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });
}


$(document).ready(function () {
  // Function to handle active state and image display for each menu
  function handleMenu(menuId) {
    // Set the first item as active by default for this menu
    var firstItem = $("#" + menuId + " .collection-item").first();
    firstItem.addClass("active");

    // Display the corresponding image for the first item
    var firstCollectionHandle = firstItem.data("collection-handle");
    $("#" + menuId + " .collection-img").each(function () {
      if ($(this).hasClass("collection-img-" + firstCollectionHandle)) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

    // On hover, update the active state and show corresponding image for the hovered item
    $("#" + menuId + " .collection-item").hover(function () {
      // Remove active state from all items in this menu
      $("#" + menuId + " .collection-item").removeClass("active");
      $(this).addClass("active");

      // Show the corresponding image for the hovered item
      var collectionHandle = $(this).data("collection-handle");
      $("#" + menuId + " .collection-img").each(function () {
        if ($(this).hasClass("collection-img-" + collectionHandle)) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    });

    // Optional: Keep the image visible when you leave the hover state (hover off)
    $("#" + menuId + " .collection-item").mouseleave(function () {
      $(this).removeClass("active");
      // You can make the first collection image visible again if desired
    });
  }

  // Handle first menu (select_menu_pTyfbX)
  handleMenu("select_menu_pTyfbX");

  // Handle second menu (select_menu_Wz4zHF)
  handleMenu("select_menu_Wz4zHF");
});

$(document).ready(function () {
  // Handle click on menu items
  $(".mobile-mega-menu > ul > li").click(function (e) {
    if ($(this).hasClass("nad-shop-item") || $(e.target).closest('a[href]:not([href="#"])').length) return;

    var targetId = $(this).attr("id");
    var targetBox = $("#" + targetId + ".mega-menu.collc-box");
    var mobileMenu = $(".nws-custom-mobile-menu");

    if (targetBox.hasClass("active")) {
      targetBox.removeClass("active");
      mobileMenu.removeClass("active");
    } else {
      $(".mega-menu.collc-box").removeClass("active");
      targetBox.addClass("active");

      mobileMenu.addClass("active");
    }
  });

  // Close menu when h4 inside is clicked
  $(".mega-menu.collc-box .collection-list h4").click(function (e) {
    var parentBox = $(this).closest(".mega-menu.collc-box");
    parentBox.removeClass("active");
    $(".nws-custom-mobile-menu").removeClass("active");
  });
});

// Open Sidebar
$(".nws-icon-open").click(function () {
  $(".nws-custom-mobile-menu").addClass("open");
  $(".nws-custom-mobile-overlay").addClass("menu-sidebar-active");
});

// Close Sidebar
jQuery(".menu-toggle-close").click(function () {
  jQuery(".nws-custom-mobile-menu").removeClass("open");
  jQuery(".nws-custom-mobile-overlay").removeClass("menu-sidebar-active");
});

// Close sidebar when clicking outside
jQuery(document).click(function (event) {
  if (
    !$(event.target).closest(".nws-custom-mobile-menu, .nws-icon-open").length
  ) {
    $(".nws-custom-mobile-menu").removeClass("open");
    $(".nws-custom-mobile-overlay").removeClass("menu-sidebar-active");
  }
});

jQuery(window).on("scroll", function () {
  if (jQuery(window).scrollTop() > 160) {
    jQuery(".nws-header").addClass("fix_head");
  } else {
    jQuery(".nws-header").removeClass("fix_head");
  }
});

jQuery(document).ready(function () {
  jQuery(".tab-title").on("click", function () {
    var currentSection = $(this).closest(".foo-toggle");

    // If the current section is not active, close all others first
    if (!currentSection.hasClass("active")) {
      jQuery(".foo-toggle.active")
        .removeClass("active")
        .find("ul.list-unstyled")
        .slideUp();

      // Then open the clicked section
      currentSection.addClass("active").find("ul.list-unstyled").slideDown();
    } else {
      // If it's already active, close it
      currentSection.removeClass("active").find("ul.list-unstyled").slideUp();
    }
  });
});

jQuery(".faq-item").click(function () {
  // Toggle the answer when clicking on a question
  jQuery(this).find(".faq-answer").slideToggle(300);

  // Close other answers
  jQuery(".faq-item").not(this).find(".faq-answer").slideUp(300);
});

jQuery(".faq-list .accordion-item").click(function () {
  if (jQuery(this).hasClass("active-drop")) {
    jQuery(".faq-list .accordion-item").removeClass("active-drop");
  } else {
    jQuery(".faq-list .accordion-item").removeClass("active-drop");
    jQuery(this).addClass("active-drop");
  }
});

jQuery(window).on("scroll", function() {
    if(jQuery(window).scrollTop() > 160) {
        jQuery(".nws-header").addClass("fix_head");
    } else {
    jQuery(".nws-header").removeClass("fix_head");
}
});

jQuery.noop && jQuery('.testimonial-slide--legacy').slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    autoplay: false,
    speed: 1000,
    autoplaySpeed: 3000,
    centerMode: true,
    centerPadding: 0,
    slidesToScroll: 1,

    responsive: [{
        breakpoint: 993,
        settings: {
            dots: false,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1
        }
    }, 

    {
      breakpoint: 768,
      settings: {
          dots: false,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1
      }
    }, 

    {
      breakpoint: 601,
      settings: {
           dots: false,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1
      }
    }, 

    {
      breakpoint: 481,
      settings: {
         dots: false,
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1
      }
    }]
}); 